module.exports = __webpack_public_path__ + "img/YQ.939598e1.png";